import React from 'react'
import '../../App.css'
import './About.css'
import BackgroundSection from '../BackgroundSection'
import ContainerSection from '../ContainerSection'
import { Title } from '../Title'
import His1 from '../../images/his1.jpg'
import His2 from '../../images/gov.svg'
import His3 from '../../images/his3.jpg'
import His4 from '../../images/his4.jpg'
import His5 from '../../images/his5.jpg'
import His6 from '../../images/his6.jpg'
import Bio from '../../images/bio.jpg'
import Bio2 from '../../images/bio2.jpg'

export const About = () => {
  return (
    <>
      <BackgroundSection
        className='background'
        backgroundStyle='background--third'
      >
        Who We Are
      </BackgroundSection>
      <ContainerSection
        className='container'
        containerStyle='container--conone'
      >
        <Title
          className='title'
          titleStyle='title--trans'
          titleSize='title--large'
        >
          History
        </Title>
        <div className='his-textpic1-container'>
          <div className='his-pic1'>
            <img className='his1' src={His1} alt='history' />
          </div>
          <div className='his-textpic12'>
            <div className='his-pic2'>
              <img className='his2' src={His2} alt='history' />
            </div>
            <div className='his-text1'>
              <Title
                className='title'
                titleStyle='title--trans'
                titleSize='title--small'
              >
                Global Partnerships for Sustainable Development
              </Title>
              <p className='about-text'>
                We mobilize global investments address critical social issues
                pertaining to agriculture and food security. We identify
                promising technologies and AI-driven solutions, and scale them
                up forglobal social impact.
              </p>
            </div>
          </div>
        </div>
        <div className='his-textpic2-container'>
          <div className='his-pic3'>
            <div className='his-pic34'>
              <img className='his3' src={His3} alt='history' />
              <img className='his4' src={His4} alt='history' />
            </div>
            <div className='his-pic56'>
              <img className='his5' src={His5} alt='history' />
              <img className='his6' src={His6} alt='history' />
            </div>
          </div>
          <div className='his-text'>
            <Title
              className='title'
              titleStyle='title--trans'
              titleSize='title--small'
            >
              Investing in the Future of Humanity
            </Title>
            <p className='about-text'>
              For over 20 years, the Mpule Foundation has been at the forefront
              of investing in the future of humanity. We are a multistakeholder,
              social impact investment firm, working to end poverty and hunger.
              Together with our global partners, we’re accelerating progress
              towards the sustainable development goals.
            </p>
            <Title
              className='title'
              titleStyle='title--trans'
              titleSize='title--small'
            >
              Multi-stakeholder, inter-disciplinary partnerships
            </Title>
            <p className='about-text'>
              We partner with Technology and business Industry leaders,
              bilateral and multilateral institutions, governments, academia,
              international organizations, civil society and nonprofits to
              ensure shared prosperity and that no one gets left behind in the
              Fourth Industrial Revolution.
            </p>
          </div>
        </div>
      </ContainerSection>
      <ContainerSection
        className='container'
        containerStyle='container--contwo'
      >
        <Title
          className='title'
          titleStyle='title--trans'
          titleSize='title--large'
        >
          Governance
        </Title>
        <div className='bio-textpic-container'>
          <div className='bio-container1'>
            <div className='bio-pic1'>
              <img className='bio' src={Bio} alt='bio' />
            </div>
            <div className='bio-text'>
              <Title
                className='title'
                titleStyle='title--trans'
                titleSize='title--small'
              >
                Biography
              </Title>
              <p className='about-text'>
                Mpule Gandhi a trained political economist and development
                practitioner with 20 years of experience and expertise in global
                development, public policy, government relations and policy
                advocacy and analysis. She holds a degree in international
                political economy from Columbia University, and served as a
                United Nations Goodwill Ambassador for 10 years. She has
                testified before the US Congress on increasing funding for
                HIV/AIDS and health systems in Sub-Saharan Africa, and lobbied
                European donor governments on behalf of the UN.
              </p>
            </div>
          </div>

          <div className='bio-container2'>
            <div className='bio-pic2'>
              <img className='bio2' src={Bio2} alt='bio' />
            </div>
            <div className='bio-text'>
              <Title
                className='title'
                titleStyle='title--trans'
                titleSize='title--small'
              >
                Awards
              </Title>
              <ul>
                <li className='about-text'>
                  Young Global Leader, World Economic Forum, 2006
                </li>
                <li className='about-text'>
                  Global Leader for Tomorrow, World Economic Forum, 2003
                </li>
                <li className='about-text'>
                  Jonathan Mann Human Health Rights Award, IAPAC, 2001
                </li>
                <li className='about-text'>
                  Presidential Award, Lions Club International 2000
                </li>
              </ul>
              <Title
                className='title'
                titleStyle='title--trans'
                titleSize='title--small'
              >
                Leadership Positions
              </Title>
              <ul>
                <li className='about-text'>
                  International Advisory Board – Agriculture and Food Security
                  Center, Columbia University
                </li>
                <li className='about-text'>
                  International Board Of Directors, African Institute for
                  Mathematical Sciences
                </li>
                <li className='about-text'>
                  Africa Policy Advisory Board Member – ONE Campaign
                </li>
              </ul>
            </div>
          </div>
        </div>
      </ContainerSection>
    </>
  )
}
